import React from 'react';
import style from './loader.module.css';

const Loader = () => {
  return (
    <div className={style.loader}></div>
  );
}

export default Loader;
